import React, { useEffect, useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMonitoringMember,
  getInternetSpeedLocation,
  getInternetSpeedLocationSummary,
} from '../../../../redux/MainAction';
import NetworkSpeedDisplay from './NetworkSpeedDisplay';
import MapModal from '../Activity/MapModal';
import { LuMapPin } from 'react-icons/lu';

const InternetSpeedLocation = () => {
  const dispatch = useDispatch();
  const member = useSelector((state) => state.Webtracker.monitoringMember);
  const activity = useSelector(
    (state) => state.Webtracker.internetSpeedLocation?.rows
  );
  const summary = useSelector(
    (state) => state.Webtracker.internetSpeedLocationSummary
  );

  const userID = localStorage.getItem('userId');
  const [dateRange, setDateRange] = useState('today');

  const [emp, setEmp] = useState([]);

  const date = new Date();

  const [filts, setFilts] = useState({
    employeeId: userID,
    startDate: moment(date).format('YYYY-MM-DD'),
  });

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);
    let start, end;
    const today = new Date();

    const currentDayOfWeek = today.getDay();
    const monday = new Date(today);
    monday.setDate(today.getDate() - currentDayOfWeek + 1);
    const sunday = new Date(today);
    sunday.setDate(today.getDate() - currentDayOfWeek + 7);

    switch (value) {
      case 'today':
        start = today;
        end = today;
        break;

      case 'thisWeek':
        start = monday;
        end = today;
        break;

      case 'last7days':
        const previousMonday = new Date(monday);
        previousMonday.setDate(monday.getDate() - 7);
        const previousSunday = new Date(sunday);
        previousSunday.setDate(sunday.getDate() - 7);

        start = previousMonday;
        end = previousSunday;
        break;

      case 'last30days':
        start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
        end = today;
        break;

      case '3months':
        start = new Date(today);
        start.setMonth(today.getMonth() - 3);
        end = today;
        break;

      default:
        return;
    }

    setFilts((prev) => ({
      ...prev,
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    }));
  };

  const onChangeFilters = (e) => {
    const { name, value } = e.target;
    setFilts({ ...filts, [name]: value });
  };

  useEffect(() => {
    if (filts?.employeeId !== '' && filts?.date !== '') {
      var data = {
        employeeIds: [filts?.employeeId],
        startDate: moment(filts?.startDate).format('YYYY-MM-DD'),
        endDate: moment(filts?.endDate).format('YYYY-MM-DD'),
      };
      dispatch(getInternetSpeedLocation(data));
      dispatch(getInternetSpeedLocationSummary(data));
    }
  }, [filts, dateRange]);

  const getList = () => {
    var data = {
      offset: 0,
      limit: 100,
    };
    dispatch(getMonitoringMember(data));
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    if (member && member?.rows) {
      setEmp(member?.rows);
    }
  }, [member]);

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-4"></h5>
          <div
            className="col-8 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          ></div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-10">
                    <div className="card-body">
                      <div
                        className="d-flex justify-content-between align-items-center "
                        style={{ gap: '10px' }}
                      >
                        <div
                          className="d-flex justify-content-start align-items-center"
                          style={{ gap: '10px' }}
                        >
                          <i
                            className="fa fa-circle text-danger"
                            style={{ fontSize: '25px' }}
                          ></i>
                          <select
                            className="form-control font-16"
                            style={{
                              maxWidth: '215px',
                              cursor: 'pointer',
                              minWidth: '170px',
                            }}
                            name="employeeId"
                            value={filts?.employeeId}
                            onChange={onChangeFilters}
                          >
                            {emp?.map((employee, idx) => (
                              <option key={idx} value={employee?.user?.id}>
                                {employee?.user?.firstName}{' '}
                                {employee?.user?.lastName}
                              </option>
                            ))}
                          </select>

                          <select
                            className="form-control font-14"
                            value={dateRange}
                            onChange={handleDateRangeChange}
                          >
                            <option value="today">Today</option>
                            <option value="thisWeek">This Week</option>
                            <option value="last7days">Last Week</option>
                            <option value="last30days">This month</option>
                            <option value="3months">3 months</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <NetworkSpeedDisplay summary={summary} />

              <div className="card m-b-20">
                <div className="card-body">
                  <div style={{ overflow: 'auto' }}>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th className="text-left">Coordinates</th>
                          <th className="text-center">City, Country</th>
                          <th className="text-center">Map</th>
                          <th className="text-right">Internet Speed</th>
                        </tr>
                      </thead>
                      <tbody>
                        {activity?.length !== 0 ? (
                          activity?.map((acts, idx) => {
                            return (
                              <tr key={idx} style={{ fontWeight: '500' }}>
                                <td
                                  style={{
                                    fontSize: '15px',
                                    lineHeight: '1.2',
                                  }}
                                  className="text-nowrap"
                                >
                                  Lat : <span>{acts?.latitude || 'N/A'}</span>
                                  <br />
                                  Long : <span>{acts?.longitude || 'N/A'}</span>
                                </td>

                                <td
                                  className="text-center text-nowrap"
                                  style={{ fontSize: '14px' }}
                                >
                                  <LuMapPin color="#3367d6" fontSize="16px" />{' '}
                                  <span>{acts?.city || 'N/A'}</span>
                                </td>

                                <td>
                                  <MapModal
                                    acts={{
                                      longitude: acts?.longitude,
                                      latitude: acts?.latitude,
                                      city: acts?.city,
                                    }}
                                    showOnlyMap={true}
                                  />
                                </td>

                                <td
                                  className="text-right"
                                  style={{ fontSize: '14px' }}
                                >
                                  {acts?.speed ? (
                                    <span className="text-nowrap">
                                      {(+acts?.speed / 1000000).toFixed(2)} Mbps
                                    </span>
                                  ) : (
                                    'N/A'
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={4} className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default InternetSpeedLocation;
